export default class UpdateWorkTypePricingError extends Error {

}
